import { InputArea } from '@wix/design-system';
import React from 'react';
import type { HTMLData } from 'ricos-schema';

import { EDIT_PANEL_HTML_INPUT } from '../../dataHooks';

type HtmlInputAreaProps = {
  placeholder: string;
  componentData: HTMLData;
  onChange: (value: HTMLData) => void;
};

export const HtmlInputArea: React.FC<HtmlInputAreaProps> = ({
  placeholder,
  componentData,
  onChange,
}) => {
  return (
    <InputArea
      placeholder={placeholder}
      dataHook={EDIT_PANEL_HTML_INPUT}
      value={componentData.html ?? ''}
      onChange={e => onChange({ ...componentData, url: undefined, html: e.target.value })}
      minHeight="135px"
      autoSelect
    />
  );
};
